// src/components/EditRetailerLimitModal.jsx
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import adminService from '../services/adminService';

const EditRetailerLimitModal = ({ show, onClose, onSubmit, user }) => {
  const [limit, setLimit] = useState(user?.userCreationLimit || 10);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (limit < 0) {
      toast.error('Limit cannot be negative');
      return;
    }

    setLoading(true);
    try {
      await onSubmit(user._id, limit);
      onClose();
    } catch (error) {
      console.error('Error updating limit:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!user) return null;

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit User Creation Limit</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">
              Retailer: <strong>{user.fullName || user.username}</strong>
            </label>
          </div>
          
          <div className="mb-3">
            <label className="form-label">Current Usage</label>
            <div className="progress mb-2">
              <div 
                className={`progress-bar ${user.usersCreatedCount >= user.userCreationLimit ? 'bg-danger' : 'bg-success'}`}
                style={{ width: `${(user.usersCreatedCount / user.userCreationLimit) * 100}%` }}
              >
                {Math.round((user.usersCreatedCount / user.userCreationLimit) * 100)}%
              </div>
            </div>
            <small className="text-muted">
              {user.usersCreatedCount} of {user.userCreationLimit} users created
            </small>
          </div>

          <div className="mb-3">
            <label htmlFor="limit" className="form-label">
              New User Creation Limit
            </label>
            <input
              type="number"
              className="form-control"
              id="limit"
              value={limit}
              onChange={(e) => setLimit(parseInt(e.target.value) || 0)}
              min="0"
              required
            />
            <small className="text-muted">
              Set 0 to disable user creation
            </small>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? 'Updating...' : 'Update Limit'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EditRetailerLimitModal;